// Re-export the refactored component
import SampleSizeCalculator from './SampleSizeCalculator/index';

export default SampleSizeCalculator;
